import axios from 'axios'
import { Promise } from 'es6-promise'

import { 
  defaultSortDirection,
  getCSRFToken,
} from '../lib/utilities'

const MAXIMUM_MIN_MINUTES = 500

function PlayerList({ players, season, playoffs }) {
  this.players = players
  this.season = season
  this.isPlayoffs = playoffs
  
  this.setSeason = (year) => {
    this.season = year
  }

  this.fetchUrl = () => {
    let baseUrl = '/api/player_seasons'
    if ( this.season ) {
      baseUrl = `/api/player_seasons?season=${this.season}`
    }
    
    if ( this.isPlayoffs ) {
      const operator = this.season ? '&' : '?'
      baseUrl += `${operator}playoffs=true`
    }
    
    return baseUrl
  }
  
  this.fetch = () => {    
    return axios({
      method: 'GET',
      url: this.fetchUrl(),
      headers: {
        'X-CSRF-Token': getCSRFToken(),
      }
    }).then((response) => {
      this.players = response.data
      this._minMinutesThreshold = void 0
    })
  }
  
  this.sortBy = (attribute, direction) => {
    const sortDirection = direction || defaultSortDirection(attribute)
    
    return this.players.sort((prev, nxt) => {
      const a = prev[attribute];
      const b = nxt[attribute];
     
      if ( a === b ) return 0;
      
      const comparison = (sortDirection === 'asc') ? (a < b) : (a > b)
      
      return comparison ? -1 : 1
    })
  }
  
  this.minMinutesThreshold = () => {
    if ( this.players.length === 0 ) {
      return 0
    }

    if ( this._minMinutesThreshold === void 0 ) {
      const totalGames = this.players.reduce((games, player) => (games + player.games), 0)
      if (totalGames === 0) {
        this._minMinutesThreshold = 0
      } else {
        const averageGames = totalGames / this.players.length
        // round to nearest ten
        const minimumMinutes = Math.round(Math.round(averageGames * 10) / 10) * 10
        this._minMinutesThreshold = Math.min(minimumMinutes, MAXIMUM_MIN_MINUTES)
      }
    }

    return this._minMinutesThreshold
  }
}

export default PlayerList


// WEBPACK FOOTER //
// ./app/javascript/models/player-list.js